import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=f2a7ba92&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7ba92",
  null
  
)

export default component.exports